module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitleRegister: 'Register with Sephora',
        modalTitleCreate: 'Create an Account'
    };

    return resources[label];
};
